module.exports = __webpack_public_path__ + "static/img/illustration_health_monitoring_device.b120145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/illustration_health_monitoring_device.png
// module id = KTEa
// module chunks = 1